import React from 'react';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';
import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const articleTabVariantImportantNotes = props => {
    const { notes } = props;
    const { translate } = useTranslationHook();

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    if (!notes.length) {
        return <></>;
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="variant-important-note-dialog-title"
                aria-describedby="variant-important-note-dialog-description"
            >
                <DialogTitle component="div">
                    <h3>
                        {translate('Important notes', { ns: 'article-detail' })}
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                padding: 0,
                                width: 'auto'
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </h3>
                </DialogTitle>
                <DialogContent>
                    <div className="grid-x">
                        {notes.map(note => {
                            return (
                                <div className="cell padding-bottom" key={note.id_important_note}>{note.text}</div>
                            );
                        })}
                    </div>
                    <div tabIndex={1} />
                </DialogContent>
            </Dialog>

            <span className="important-notes" onClick={handleClickOpen}>{translate('Important notes', { ns: 'article-detail' })}</span>
        </>
    );
};

export default articleTabVariantImportantNotes;
